"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var BurgerText32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M1 32h30a1 1 0 000-2H1a1 1 0 000 2zM1 24h30a1 1 0 000-2H1a1 1 0 000 2zM1 16h30a1 1 0 000-2H1a1 1 0 000 2zM0 9.944V1.831h1.055l2.909 4.196 2.897-4.196h1.055v8.113h-.927V3.291L3.952 7.556.927 3.279v6.664H0zm9.863 0V1.831h5.563V2.7h-4.59v2.7h4.138v.823h-4.138v2.851h4.659v.869H9.862zm7.36 0V1.831h.985l4.532 6.606V1.831h.939v8.113h-1.008l-4.508-6.595v6.595h-.939zm10.454-8.889a.486.486 0 01-.359-.157c-.046-.05-.083-.106-.11-.168s-.041-.131-.041-.209A.52.52 0 0127.48.04a.49.49 0 01.197-.041.555.555 0 01.504.313.516.516 0 01.041.209.52.52 0 01-.331.493.559.559 0 01-.214.041zm2.237 0c-.07 0-.137-.014-.203-.041s-.122-.066-.168-.116c-.046-.05-.083-.106-.11-.168s-.041-.131-.041-.209a.52.52 0 01.151-.371.53.53 0 01.371-.151.555.555 0 01.382.151.522.522 0 01.11.58.602.602 0 01-.11.168c-.046.05-.102.089-.168.116s-.137.041-.214.041zm-1.124 9.028c-.456 0-.879-.066-1.269-.197s-.73-.33-1.02-.597c-.29-.267-.516-.597-.678-.991s-.243-.846-.243-1.356V1.831h.974v5.111c0 .363.056.69.168.979s.27.531.475.724c.205.193.444.34.719.44s.566.151.875.151c.309 0 .601-.05.875-.151s.514-.247.719-.44c.205-.193.363-.435.475-.724s.168-.616.168-.979V1.831h.974v5.111c0 .51-.081.962-.243 1.356s-.388.724-.678.991c-.29.267-.63.466-1.02.597s-.813.197-1.269.197z" }))); };
var StyledBurgerText32 = styled_components_1.default(BurgerText32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledBurgerText32;
var templateObject_1;
//# sourceMappingURL=BurgerText32.js.map